/* ==========================================================================
   Helium Deco V3 — Gallery Page Interactions
   - Mobile menu, category filtering, lightbox
   ========================================================================== */

document.addEventListener('DOMContentLoaded', () => {

    /* Mobile menu toggle is handled globally in v3-main.js (event-delegated).
       The duplicate handler that used to live here double-toggled the drawer
       on the gallery page, so it opened then immediately closed. Removed. */

    /* =====================================================================
       CATEGORY FILTERING
       ===================================================================== */

    const filters = document.querySelectorAll('.gallery-page__filter');
    const items = document.querySelectorAll('.gallery-item');
    const grid = document.querySelector('.gallery-page__grid');

    filters.forEach(btn => {
        btn.addEventListener('click', () => {
            const filter = btn.dataset.filter;

            filters.forEach(f => f.classList.remove('gallery-page__filter--active'));
            btn.classList.add('gallery-page__filter--active');

            items.forEach(item => {
                if (filter === 'all' || item.dataset.category === filter) {
                    item.classList.remove('gallery-item--hidden');
                } else {
                    item.classList.add('gallery-item--hidden');
                }
            });

            // Replay the fade-in on the remaining items so the change is
            // unmistakable — without it the grid snaps instantly and the
            // filter can read as a dead button.
            if (grid) {
                grid.classList.remove('gallery-page__grid--filtered');
                void grid.offsetWidth; // restart the CSS animation
                grid.classList.add('gallery-page__grid--filtered');
            }
        });
    });


    /* =====================================================================
       LIGHTBOX
       ===================================================================== */

    const lightbox = document.getElementById('lightbox');
    const lbImg = document.getElementById('lightboxImg');
    const lbLabel = document.getElementById('lightboxLabel');
    const lbLocation = document.getElementById('lightboxLocation');
    const lbClose = lightbox?.querySelector('.lightbox__close');
    const lbPrev = lightbox?.querySelector('.lightbox__prev');
    const lbNext = lightbox?.querySelector('.lightbox__next');

    let currentIndex = 0;

    function getVisibleItems() {
        return Array.from(items).filter(i => !i.classList.contains('gallery-item--hidden'));
    }

    function openLightbox(index) {
        const visible = getVisibleItems();
        if (index < 0 || index >= visible.length) return;
        currentIndex = index;

        const item = visible[index];
        const img = item.querySelector('img');
        const label = item.querySelector('.gallery-item__label');
        const location = item.querySelector('.gallery-item__location');

        if (lbImg) lbImg.src = img.src;
        if (lbLabel) lbLabel.textContent = label?.textContent || '';
        if (lbLocation) lbLocation.textContent = location?.textContent || '';

        lightbox.classList.add('is-open');
        document.body.style.overflow = 'hidden';
    }

    function closeLightbox() {
        lightbox?.classList.remove('is-open');
        document.body.style.overflow = '';
    }

    function navigate(dir) {
        const visible = getVisibleItems();
        currentIndex = (currentIndex + dir + visible.length) % visible.length;
        openLightbox(currentIndex);
    }

    items.forEach(item => {
        item.addEventListener('click', () => {
            const visible = getVisibleItems();
            const index = visible.indexOf(item);
            if (index >= 0) openLightbox(index);
        });
    });

    lbClose?.addEventListener('click', closeLightbox);
    lbPrev?.addEventListener('click', () => navigate(-1));
    lbNext?.addEventListener('click', () => navigate(1));

    document.addEventListener('keydown', (e) => {
        if (!lightbox?.classList.contains('is-open')) return;
        if (e.key === 'Escape') closeLightbox();
        if (e.key === 'ArrowLeft') navigate(-1);
        if (e.key === 'ArrowRight') navigate(1);
    });

    // Close on backdrop click
    lightbox?.addEventListener('click', (e) => {
        if (e.target === lightbox) closeLightbox();
    });
});
